import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { checkPermission } from "./HelperFunction";

function ProtectedRouter({
  element,
  isProtected,
  requiredPermission,
  requiredSubPermission,
}) {
  const isAuthenticated = useSelector((state) => state.authReducer.isLogin);
  const user = useSelector((state) => state.authReducer.user);
  const location = useLocation();

  // route is protected and user is not authenticated
  if (isProtected && !isAuthenticated) {
    return <Navigate replace to="/login" />;
  }

  // redirect to dashboard if user is authenticated and tries to unauthorized routes
  if (isAuthenticated && !isProtected) {
    return <Navigate replace to="/" />;
  }

  // Check specific permissions if required
  if (
    isProtected &&
    isAuthenticated &&
    requiredPermission &&
    requiredSubPermission
  ) {
    const hasPermission = checkPermission(
      user?.role?.permissions,
      requiredPermission,
      requiredSubPermission
    );

    if (!hasPermission) {
      // Redirect to the main page of the module or dashboard
      const mainModulePath = getMainModulePath(location.pathname);
      return <Navigate replace to={mainModulePath} />;
    }
  }

  return element;
}

// Helper function to get the main module path from a nested route
function getMainModulePath(currentPath) {
  // Extract the main module from the current path
  const pathSegments = currentPath.split("/").filter((segment) => segment);

  if (pathSegments.length > 0) {
    const mainModule = pathSegments[0];
    return `/${mainModule}`;
  }

  return "/";
}

export default ProtectedRouter;
